import { StatusDto } from './statusdto';
import { APIResponse, APIResponseDtoImpl } from '../api/apiresponse';

//MVPDto
export interface MVPDto extends APIResponse 
{
    getIsSuccess(): boolean;
   // getDescription() : string;
    getStatus() : StatusDto;
}

export class MVPDtoImpl extends APIResponseDtoImpl implements MVPDto
{
    private isSuccess: boolean;
   // private description: string;
    private status : StatusDto;

    getIsSuccess(): boolean 
    {
        return this.isSuccess;
    }
    setSuccess(isSuccess: boolean)
    {
        this.isSuccess = isSuccess;
    }
    /* getDescription(): string 
    {
        return this.description;
    }
    setDescription(description: string)
    {
        this.description = description;
    } */
    getStatus(): StatusDto
    {
        return this.status;
    }
    setStatus(status: StatusDto)
    {
        this.status = status;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/mvpdto.tsx